<template>
	<div :class="`colored-text-status bold ${theme}`">
		{{ text }}
	</div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'ColoredTextStatus',

	props: {
		text: {
			type: String,
			required: true
		},
		theme: {
			type: String,
			required: true
		}
	}
})
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.colored-text-status {
	width: fit-content;
	padding: 7px 10px;
	font-size: 12px;
	line-height: 15px;
	letter-spacing: 0.05em;
	color: $white;
	border-radius: 4px;

	&.green {
		background-color: $hard-green;
	}

	&.red {
		background-color: $natural-red;
	}

	&.blue {
		background-color: $semi-dark-blue;
	}

	&.purple {
		background-color: $blue-faceless-void;
	}
}
</style>
